import { ForwardedRef, forwardRef } from 'react'

import { TextField, Props as TextFieldProps } from './TextField'

type Props = Omit<TextFieldProps, 'icon'> & {
    onSearch?: (q: string) => void
}

export const SearchField = forwardRef(
    (
        { size = 'small', placeholder, onSearch, onChange, ...props }: Props,
        forwardedRef: ForwardedRef<HTMLInputElement>
    ) => {
        return (
            <TextField
                ref={forwardedRef}
                size={size}
                icon={size === 'small' ? 'magnifier.small' : 'magnifier.medium'}
                placeholder={placeholder || 'Search'}
                onChange={!!onSearch ? (e) => onSearch(e.target.value.trimStart()) : onChange}
                {...props}
            />
        )
    }
)
SearchField.displayName = 'SearchField'
